import { render, staticRenderFns } from "./LinkPicker.vue?vue&type=template&id=31bd95c1&scoped=true&"
import script from "./LinkPicker.vue?vue&type=script&lang=js&"
export * from "./LinkPicker.vue?vue&type=script&lang=js&"
import style0 from "./LinkPicker.vue?vue&type=style&index=0&id=31bd95c1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31bd95c1",
  null
  
)

export default component.exports